import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";
import {
    TAGS_INIT,
    TAGS_RESET,
    TAGS_FETCH_BEGIN,
    TAGS_FETCH_SUCCESS,
    TAGS_FETCH_FAIL,
    TAG_CREATE_BEGIN,
    TAG_CREATE_SUCCESS,
    TAG_CREATE_FAIL,
    TAG_UPDATE_BEGIN,
    TAG_UPDATE_SUCCESS,
    TAG_UPDATE_FAIL,
    TAG_DELETE_BEGIN,
    TAG_DELETE_SUCCESS,
    TAG_DELETE_FAIL,
    TAG_SUPPLIER_ASSIGN_BEGIN,
    TAG_SUPPLIER_ASSIGN_SUCCESS,
    TAG_SUPPLIER_ASSIGN_FAIL,
    TAGGED_SUPPLIERS_FETCH_BEGIN,
    TAGGED_SUPPLIERS_FETCH_SUCCESS,
    TAGGED_SUPPLIERS_FETCH_FAIL,
    TAG_SUPPLIER_REMOVE_BEGIN,
    TAG_SUPPLIER_REMOVE_SUCCESS,
    TAG_SUPPLIER_REMOVE_FAIL,
} from "actions/tagsActions";

const INITIAL_STATE = { data: [], status: "uninitialized" };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case TAGS_INIT:
            return { ...INITIAL_STATE, status: "initialized" };

        case TAGS_FETCH_BEGIN:
            return { ...INITIAL_STATE, status: "fetching" };

        case TAGS_FETCH_SUCCESS:
            return { data: action.data, status: "idle" };

        case TAGS_FETCH_FAIL:
            return { ...INITIAL_STATE, status: "failed", failReason: action.reason };

        case TAG_CREATE_BEGIN:
            return { ...state, status: "creating" };

        case TAG_CREATE_SUCCESS:
            return update(state, { status: { $set: "success" }, data: { $push: [action.tag] } });

        case TAG_CREATE_FAIL:
            return { ...state, status: "failed", error: action.error };

        case TAG_UPDATE_BEGIN:
            return { ...state, status: "updating" };

        case TAG_UPDATE_SUCCESS:
            return update(state, {
                data: { [action.index]: { $set: action.newData } },
                status: { $set: "success" },
            });

        case TAG_UPDATE_FAIL:
            return { ...state, status: "failed", failReason: action.reason };

        case TAG_DELETE_BEGIN:
            return { ...state, status: "fetching" };

        case TAG_DELETE_SUCCESS:
            return update(state, {
                data: { $splice: [[action.index, 1]] },
                status: { $set: "success" },
            });

        case TAG_DELETE_FAIL:
            return { ...state, status: "failed", failReason: action.reason };

        case TAG_SUPPLIER_ASSIGN_BEGIN:
            return { ...state, status: "assigning" };

        case TAG_SUPPLIER_ASSIGN_SUCCESS:
            return { ...state, status: "success" };

        case TAG_SUPPLIER_ASSIGN_FAIL:
            return { ...state, status: "failed", error: action.error };

        case TAGGED_SUPPLIERS_FETCH_BEGIN:
            return { ...state, status: "fetching" };

        case TAGGED_SUPPLIERS_FETCH_SUCCESS:
            return { ...state, status: "success" };

        case TAGGED_SUPPLIERS_FETCH_FAIL:
            return { ...state, status: "failed", error: action.error };

        case TAG_SUPPLIER_REMOVE_BEGIN:
            return { ...state, status: "removing" };

        case TAG_SUPPLIER_REMOVE_SUCCESS:
            return { ...state, status: "success" };

        case TAG_SUPPLIER_REMOVE_FAIL:
            return { ...state, status: "failed", error: action.error };

        case TAGS_RESET:
            return INITIAL_STATE;

        default:
            return state;
    }
};
